import { configureStore } from '@reduxjs/toolkit';
import interviewReducer from './slices/interview';

export default configureStore({
  reducer: {
    interview: interviewReducer,
  },
});
